class Carousel extends HTMLElement {
  constructor() {
    super();
    this.showNavigation = this.dataset.showNavigation === "true";
    this.spaceBetween = parseInt(this.dataset.spaceBetween, 10);
    this.disableBelowBreakpoint = this.dataset.disableBelowBreakpoint;
    this.disableAboveBreakpoint = this.dataset.disableAboveBreakpoint;
    this.slides = this.querySelectorAll(".swiper-slide");

    window.loadSwiper.then(({ Swiper, Navigation, EffectFade }) => {
      this.Swiper = Swiper;
      this.Navigation = Navigation;
      this.EffectFade = EffectFade;

      // Disable below / above should not be used in conjunction with eachother.
      if (this.disableBelowBreakpoint || this.disableAboveBreakpoint) {
        if (this.disableAboveBreakpoint) {
          !window.matchMedia(`(min-width: ${this.disableAboveBreakpoint}px)`)
            .matches && this.initSwiper();
          window.addEventListener("resize", () =>
            this.handleDisableAboveResize(),
          );
        } else {
          !window.matchMedia(`(max-width: ${this.disableBelowBreakpoint}px)`)
            .matches && this.initSwiper();
          window.addEventListener("resize", () =>
            this.handleDisableBelowResize(),
          );
        }
      } else {
        this.initSwiper();
      }
    });
  }

  initSwiper() {
    const swiperParams = {
      modules: [],
      slidesPerView: "auto",
      breakpoints: this.getBreakPointSpacing(),
      spaceBetween: this.spaceBetween,
    };

    if (this.dataset.showNavigation === "true") {
      swiperParams.modules.push(this.Navigation);
      swiperParams.navigation = {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      };
    }

    if (this.dataset.shouldFade === "true") {
      swiperParams.modules.push(this.EffectFade);
      swiperParams.effect = "fade";
      swiperParams.fadeEffect = {
        crossFade: true,
      };
    }

    if (this.dataset.shouldLoop === "true") {
      swiperParams.loop = true;
    }

    if (this.dataset.autoPlay !== "0") {
      swiperParams.autoplay = {
        delay: parseInt(this.dataset.autoPlay, 10),
      };
    }

    swiperParams.on = {
      init: (swiper) => {
        if (this.dataset.navigationAlignmentTarget) {
          this.updateNavPosition(swiper);
        }
      },
      slideChange: (swiper) => {
        if (this.dataset.navigationAlignmentTarget) {
          this.updateNavPosition(swiper);
        }
      },
      resize: (swiper) => {
        if (this.dataset.navigationAlignmentTarget) {
          this.updateNavPosition(swiper);
        }
      },
    };

    this.swiper = new this.Swiper(this, swiperParams);
  }

  handleDisableAboveResize() {
    if (
      window.matchMedia(`(min-width: ${this.disableAboveBreakpoint}px)`).matches
    ) {
      this.swiper?.destroy(true, true);
      this.swiper = null;
    } else {
      !this.swiper && this.initSwiper();
    }
  }

  handleDisableBelowResize() {
    if (
      window.matchMedia(`(max-width: ${this.disableBelowBreakpoint}px)`).matches
    ) {
      this.swiper?.destroy(true, true);
      this.swiper = null;
    } else {
      !this.swiper && this.initSwiper();
    }
  }

  getBreakPointSpacing() {
    const spacing = {};
    const themeSpacing = {
      phone: 640,
      tablet: 768,
      "tablet-wide": 1024,
      desktop: 1400,
      "desktop-large": 1920,
      "desktop-ultra-large": 1920,
    };

    Object.entries(themeSpacing).forEach(([key, value]) => {
      const datasetKey = this.convertToDatasetKey(key);

      if (this.dataset[datasetKey]) {
        spacing[value] = {
          spaceBetween: parseInt(this.dataset[datasetKey], 10),
        };
      }
    });

    return spacing;
  }

  convertToDatasetKey = (key) => {
    const parts = key.split("-");
    const capitalizedParts = parts.map(
      (part) => part.charAt(0).toUpperCase() + part.slice(1),
    );

    return `bpSpacing${capitalizedParts.join("")}`;
  };

  goToSlide(index) {
    this.swiper?.slideTo(index);
  }

  update() {
    this.swiper?.update();
  }

  updateNavPosition(swiperInstance) {
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (!activeSlide) return;

    const imgContainer = activeSlide.querySelector(
      `.${this.dataset.navigationAlignmentTarget}`,
    );
    if (!imgContainer) return;

    const imgHeight = imgContainer.offsetHeight;

    this.style.setProperty("--current-alignment-height", `${imgHeight}px`);
  }
}

if (!customElements.get("component-carousel")) {
  customElements.define("component-carousel", Carousel);
}
